<template>
    <div class="c-filter-checkbox u-pos-relative" v-click-outside="closeFilter" :style="width > 0 ? 'width:' + width + 'px;': ''">
        <button class="c-filter-checkbox__toggle c-button--icon" :class="{'is-open': open}" type="button" @click="toggleFilter" :title="selectionHints">
            <div class="c-filter-checkbox-hints">{{ filterName }}
                <template v-if="checkedItems.length > 0">:</template>
                <span v-if="checkedItems.length > 0" class="u-opacity-50">{{ selectionHints }}</span>
            </div>
            <!-- Arrow down icon -->
            <svgicon class="svg-down" name="arrow-rounded" width="5.5" height="5"></svgicon>
        </button>
        <div class="c-filter-checkbox-dropdown" v-show="open">
            <v-input v-if="items.length > 5" :name="filterName" input-size="small" ref="search" class="u-margin-bottom-tiny" :fluid="true" placeholder="Zoeken.." :horizontal="false" type="search" v-model="search"></v-input>
            <div class="c-filter-checkbox-empty" v-if="filteredItems.length === 0">
                {{ $t('filters.no_result') }}
            </div>
            <div class="u-padding-tiny">
                <div class="c-filter-checkbox-options">
                    <v-filter-checkbox-element
                        v-for="item in filteredItems" :name="item[itemName]+item[itemValue]"
                        :key="item[itemValue]" :value="item"
                        @item-selected="itemSelected">
                        {{item[itemName]}} <span v-if="item.Count && item.Count > 0" style="font-size: smaller">({{ item.Count }})</span>
                    </v-filter-checkbox-element>
                </div>
                <button v-if="checkedItems.length > 0 && allowMultiple" type="button" class="c-button--reset e-link u-text-underline u-margin-top-tiny" @click="uncheckAll">Deselecteer alles</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VFilterCheckboxElement from '@/components/form/filters/FilterCheckboxElement'
    import VInput from '@/components/form/Input'
    import vClickOutside from 'v-click-outside';

    // Register outside Click plugin
    Vue.use(vClickOutside);

    export default {
        props: {
            items: {type: Array, default: () => []},
            filterName: String,
            itemName: {type: String, default: 'name'},
            itemValue: {type: String, default: 'value'},
            allowMultiple: {type: Boolean, default: true },
            width: {type: Number, default:0}
        },
        data() {
            return {
                open: false,
                search: ''
            }
        },
        components: {
            VFilterCheckboxElement,
            VInput,
        },
        watch: {
            open() {
                if (this.open && typeof this.$refs.search !== 'undefined') {
                    this.$nextTick(() => this.$refs.search.$el.querySelector('input').focus());
                }
            }
        },
        mounted() {
            document.addEventListener("keydown", (e) => {
                if (this.open && e.keyCode === 27) {
                    this.closeFilter();
                }
            });
        },
        computed: {
            checkedItems() {
                let output = [];
                this.items.map(item => {
                    if (item.IsSelected) {
                        output.push(item);
                    }
                });
                return output;
            },
            filteredItems() {
                if (typeof this.items !== "undefined") {
                    
                    return this.items.filter(item => {
                        if(item[this.itemName] != null){
                            return item[this.itemName].toLowerCase().indexOf(this.search.toLowerCase()) > -1
                        }   
                    })
                }
            },
            selectionHints() {
                return this.checkedItems.map(item => {
                    return `${item[this.itemName]}`
                }).join();
            }
        },
        methods: {
            itemSelected(value) {
                //if allowMultiple = false -> uncheck all that don't have this value
                if(!this.allowMultiple) {
                    this.items.forEach(item => {
                        if(item.Value !== value)
                        {
                            item.IsSelected = false;
                        }
                    });
                }

                this.$emit('input', this.checkedItems);
                this.$emit('change');
            },
            toggleFilter() {
                this.open = !this.open;
            },
            openFilter() {
                this.open = true;
            },
            closeFilter() {
                this.open = false;
            },
            uncheckAll() {
                this.$emit('input', []);
                this.$emit('change');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-filter-checkbox {
        display: flex;
        align-items: center;
        width: 105px;
    }

    .c-filter-checkbox-hints {
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .c-filter-checkbox__toggle {
        position: relative;
        width: 100%;
        background-color: white;
        border: none;
        box-shadow: inset 0 0 0 1px palette(color-neutral, medium);
        padding: em($global-spacing-unit-tiny*1.5) em($global-spacing-unit-small);
        padding-right: em($global-spacing-unit*1.25);
        text-align: left;

        @include down($desktop) {
            padding: em($global-spacing-unit-tiny) em($global-spacing-unit-tiny);
            padding-right: em($global-spacing-unit);
        }


        svg {
            position: absolute;
            right: em($global-spacing-unit-small);
            top: 50%;
            transform: translateY(-50%);
            fill: $color-alpha;

            &.svg-down {
                transform: translateY(-50%) rotate(90deg);
            }
        }

        &.is-open {
            @include focus();
        }
    }

    .c-filter-checkbox-dropdown {
        margin: 0;
        list-style: none;
        background-color: white;
        position: absolute;
        z-index: 100;
        top: 100%;
        width: 100%;
        min-width: em(265px);
        box-shadow: 0 0 0 3px $color-neutral, 0 0 30px 0 rgba($color-base, .1);
        padding: em($global-spacing-unit-small);
    }

    .c-filter-checkbox-options {
        max-height: 400px;
        overflow-y: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/form/filters/FilterCheckbox.vue